import { useTranslation } from "react-i18next";

const en = {
  pending:
    "Policy change unresolved. Stock and receiving remain unavailable. Refresh only reads; Review and Confirm retry the original request with its original identity.",
  readback: "The policy readback does not yet confirm the acknowledged change.",
};
const nl: typeof en = {
  pending:
    "Beleidswijziging nog niet opgehelderd. Voorraad en ontvangst blijven niet beschikbaar. Vernieuwen leest alleen; Controleren en Bevestigen herhalen het oorspronkelijke verzoek met dezelfde identiteit.",
  readback: "De beleidscontrole bevestigt de erkende wijziging nog niet.",
};
const fr: typeof en = {
  pending:
    "Modification de politique non résolue. Le stock et la réception restent indisponibles. Actualiser ne fait que lire ; Vérifier et Confirmer réessaient la demande initiale avec son identité d’origine.",
  readback:
    "La relecture de la politique ne confirme pas encore la modification reconnue.",
};
export function usePolicyRecoveryText(): typeof en {
  const { i18n } = useTranslation();
  const language = (i18n.resolvedLanguage || i18n.language || "en").split(
    "-",
  )[0];
  return { en, nl, fr }[language as "en" | "nl" | "fr"] || en;
}
